import api from '../api';
import { NursingAssessmentData, DoctorOrderData, NursingNoteData } from './types';

export const nursingApi = {
  getPatients: async (params?: any) => (await api.get('/nursing/patients', { params })).data,
  
  storeAssessment: async (data: NursingAssessmentData) => (await api.post('/nursing/assessment', data)).data,
  updateAssessment: async (id: number, data: Partial<NursingAssessmentData>) => (await api.put(`/nursing/assessment/${id}`, data)).data,
  getAssessmentHistory: async (patientId: number, params?: any) => (await api.get(`/nursing/patient/${patientId}/assessments`, { params })).data,
  
  getDoctorOrders: async (params?: any) => (await api.get('/nursing/doctor-orders', { params })).data,
  storeDoctorOrder: async (data: DoctorOrderData) => (await api.post('/nursing/doctor-orders', data)).data,
  executeDoctorOrder: async (orderId: number, executionNotes?: string) => (await api.post(`/nursing/doctor-orders/${orderId}/execute`, { execution_notes: executionNotes })).data,
  updateDoctorOrderStatus: async (orderId: number, status: string, notes?: string) => (await api.put(`/nursing/doctor-orders/${orderId}/status`, { status, notes })).data,
  
  getNursingNotes: async (patientId: number, params?: any) => (await api.get(`/nursing/patient/${patientId}/notes`, { params })).data,
  storeNursingNote: async (data: NursingNoteData) => (await api.post('/nursing/nursing-notes', data)).data,
  updateNursingNote: async (noteId: number, data: Partial<NursingNoteData>) => (await api.put(`/nursing/nursing-notes/${noteId}`, data)).data,
  
  storeNotes: async (data: any) => (await api.post('/nursing/notes', data)).data,
  executeOrder: async (data: any) => (await api.post('/nursing/execute-order', data)).data,
  
  getWorkloadSummary: async (date?: string) => (await api.get('/nursing/workload-summary', { params: { date } })).data,
  cancelVisit: async (visitId: number | string, reason?: string) => (await api.put(`/nursing/visits/${visitId}/cancel`, { reason })).data,
};
